import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { UserLogin } from '../../models/user-login.model';
import { AlertService, DialogType, MessageSeverity } from '../../services/alert.service';
import { AuthService } from "../../services/auth.service";
import { ConfigurationService } from '../../services/configuration.service';
import { Utilities } from '../../services/utilities';


@Component({
    selector: "app-login",
    template: require('./login.component.html'),
    styles: [require('./login.component.css')]
})

export class LoginComponent implements OnInit, OnDestroy {
    private subscribers: Subscription[] = [];
    userLogin = new UserLogin();
    isLoading = false;
    formResetToggle = true;
    modalClosedCallback: () => void;
    loginStatusSubscription: any;

    @Input()
    isModal = false;


    constructor(private alertService: AlertService, private authService: AuthService, private configurations: ConfigurationService) {
    }


    ngOnInit() {

        this.userLogin.rememberMe = this.authService.rememberMe;

        if (this.getShouldRedirect()) {
            this.authService.redirectLoginUser();
        }
        else {
            this.loginStatusSubscription = this.authService.getLoginStatusEvent().subscribe(isLoggedIn => {
                if (this.getShouldRedirect()) {
                    this.authService.redirectLoginUser();
                }
            }, error => {
                throw error;
            });
            this.subscribers.push(this.loginStatusSubscription);
        }
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    getShouldRedirect() {
        return !this.isModal && this.authService.isLoggedIn && !this.authService.isSessionExpired;
    }

    showErrorAlert(caption: string, message: string) {
        this.alertService.showMessage(caption, message, MessageSeverity.error);
    }

    closeModal() {
        if (this.modalClosedCallback) {
            this.modalClosedCallback();
        }
    }

    login() {
        this.isLoading = true;
        this.alertService.startLoadingMessage("", "Poging tot inloggen ...");

        const loginAuthSubscriber = this.authService.login(this.userLogin.email, this.userLogin.password, this.userLogin.rememberMe)
            .subscribe(
                user => {
                    // Add Extra Details in User Object to update it in Session Storage
                    this.authService.setExtraUserInfo(user, this.userLogin.rememberMe);
                    setTimeout(() => {
                        this.alertService.stopLoadingMessage();
                        this.isLoading = false;
                        this.reset();

                        if (!this.isModal) {
                            this.alertService.showMessage("Login", `Welkom ${user.UserName}!`, MessageSeverity.success);
                        }
                        else {
                            this.alertService.showMessage("Login", `Sessie voor ${user.UserName} hersteld!`, MessageSeverity.success);
                            setTimeout(() => {
                                this.alertService.showStickyMessage("Sessie hersteld", "Probeer uw laatste bewerking opnieuw", MessageSeverity.default);
                            }, 500);

                            this.closeModal();
                        }
                    }, 500);
                },
                error => {
                    this.alertService.stopLoadingMessage();

                    if (Utilities.checkNoNetwork(error)) {
                        this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
                        this.offerAlternateHost();
                    }
                    else {
                        let errorMessage = Utilities.findHttpResponseMessage("error_description", error);

                        if (errorMessage)
                            this.alertService.showStickyMessage("Niet mogelijk om in te loggen", errorMessage, MessageSeverity.error, error);
                        else
                            this.alertService.showStickyMessage("Niet mogelijk om in te loggen", "Er is een fout opgetreden tijdens het inloggen. Probeer het later opnieuw.\nError: " + error.statusText || error.status, MessageSeverity.error, error);
                    }

                    setTimeout(() => {
                        this.isLoading = false;
                    }, 500);
                });
        this.subscribers.push(loginAuthSubscriber);
    }

    offerAlternateHost() {
        if (Utilities.checkIsLocalHost(location.origin) && Utilities.checkIsLocalHost(this.configurations.baseUrl)) {
            this.alertService.showDialog("Dear Developer!\nIt appears your backend Web API service is not running...\n" +
                "Would you want to temporarily switch to the online Demo API below?(Or specify another)",
                DialogType.prompt,
                (value: string) => {
                    this.configurations.baseUrl = value;
                    this.alertService.showStickyMessage("API Changed!", "The target Web API has been changed to: " + value, MessageSeverity.warn);
                },
                null,
                null,
                null,
                this.configurations.fallbackBaseUrl);
        }
    }

    reset() {
        this.formResetToggle = false;

        setTimeout(() => {
            this.formResetToggle = true;
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/login/login.component.ts